/**
 * Utility functions for CPF validation and formatting (Receita Federal algorithm)
 */

export function cleanCPF(cpf: string): string {
  return (cpf || '').replace(/\D/g, '').slice(0, 11);
}

export function formatCPF(cpf: string): string {
  const digits = cleanCPF(cpf);
  if (!digits) return '';
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  if (digits.length <= 9) return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9, 11)}`;
}

export function validateCPF(cpf: string): { isValid: boolean; message: string } {
  const digits = cleanCPF(cpf);

  if (!digits) {
    return { isValid: false, message: 'CPF é obrigatório para envios ao Brasil.' };
  }

  if (digits.length < 11) {
    return { isValid: false, message: `CPF incompleto (${digits.length}/11 dígitos).` };
  }

  // Check for known invalid CPFs with identical digits (00000000000, 11111111111, etc.)
  if (/^(\d)\1{10}$/.test(digits)) {
    return { isValid: false, message: 'CPF inválido (sequência de números repetidos).' };
  }

  // Validate 1st check digit
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(digits.charAt(i), 10) * (10 - i);
  }
  let rev = (sum * 10) % 11;
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(digits.charAt(9), 10)) {
    return { isValid: false, message: 'CPF inexistente/inválido (dígito verificador incorreto).' };
  }

  // Validate 2nd check digit
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(digits.charAt(i), 10) * (11 - i);
  }
  rev = (sum * 10) % 11;
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(digits.charAt(10), 10)) {
    return { isValid: false, message: 'CPF inexistente/inválido (dígito verificador incorreto).' };
  }

  return { isValid: true, message: 'CPF autêntico e verdadeiro (Receita Federal)' };
}
